var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"128a44888370382235df384e56e679c003f567d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["padhaai-about@gurucool-xyz"]={id:"128a44888370382235df384e56e679c003f567d8"};
      